import { render, staticRenderFns } from "./sdproduct9.vue?vue&type=template&id=4f0be154&scoped=true"
import script from "./sdproduct9.vue?vue&type=script&lang=js"
export * from "./sdproduct9.vue?vue&type=script&lang=js"
import style0 from "./sdproduct9.vue?vue&type=style&index=0&id=4f0be154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0be154",
  null
  
)

export default component.exports